import * as React from 'react';
import { rem } from 'polished';
import { styled } from '../themeContext';
import { graphql, useStaticQuery, navigate } from 'gatsby';

type LanguageSelectorProps = {
  className?: string,
  currentLocale: string,
};

const LANGUAGES = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
  'zh-Hant': '繁體中文',
  th: 'ภาษาไทย',
  de: 'Deutsch',
  fr: 'Français',
} as const;

const Container = styled.div(props => ({
  display: 'inline-flex',
  alignItems: 'center',
  position: 'relative',
  '&:after': {
    fontSize: rem(10),
    content: '"▼"',
    display: 'inline',
    position: 'absolute',
    right: rem(15),
    color: '#fff',
    top: '50%',
    transform: 'translateY(-50%)',
  },
  [props.theme.media['lg']]: {
    display: 'none',
  },
}));

const Select = styled.select(props => ({
  color: '#fff',
  background: 'none',
  border: '1px solid #fff',
  padding: `${rem(5)} ${rem(5)} ${rem(5)} ${rem(10)}`,
  borderRadius: 0,
  boxSizing: 'border-box',
  appearance: 'none',
  width: rem(120),
  fontSize: rem(16),
  [props.theme.media['sm']]: {
    padding: `${rem(5)} ${rem(10)}`,
  },
}));
const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  children,
  className,
  currentLocale,
}) => {
  const data = useStaticQuery<GatsbyTypes.LanguageSelectorQuery>(graphql`
    query LanguageSelector {
      allEventTarget {
        nodes {
          language
        }
      }
    }
  `);
  type Language = 'ko' | 'en' | 'ja' | 'zh-Hant' | 'th' | 'fr' | 'de';
  type Locale = { language: Language };
  const locales = data.allEventTarget.nodes as Array<Locale>;
  const handleChange: React.ChangeEventHandler<HTMLSelectElement> = (e) => {
    const locale = e.currentTarget.value;
    navigate(`/${locale}/`, { replace: true });
  };

  return (
    <Container className={className}>
      <Select
        defaultValue={currentLocale}
        onChange={handleChange}
      >
        {locales.map(locale => (
          <option
            key={locale.language}
            value={locale.language}
          >
            {LANGUAGES[locale.language]}
          </option>
        ))}
      </Select>
    </Container>
  );
};

export default LanguageSelector;
